/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { IbanAttribute } from "./IbanAttribute";
import { IbanMaster } from "./IbanMaster";
import * as t from "io-ts";

// required attributes
const IbanAttributeMasterR = t.interface({});

// optional attributes
const IbanAttributeMasterO = t.partial({
  fkAttribute: t.Integer,

  fkIbanMaster: t.Integer,

  ibanAttribute: IbanAttribute,

  objId: t.Integer
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type IbanAttributeMaster = t.TypeOf<typeof IbanAttributeMasterR> &
  t.TypeOf<typeof IbanAttributeMasterO> & {
  readonly "ibanMaster"?: IbanMaster;
  };

export const IbanAttributeMaster: t.Type<IbanAttributeMaster> = t.recursion("IbanAttributeMaster", () =>
  t.intersection(
    [IbanAttributeMasterR, t.partial({ ...IbanAttributeMasterO.props, "ibanMaster": IbanMaster })],
    "IbanAttributeMaster"
  ) as unknown as t.Type<IbanAttributeMaster>
);
